
Vue.component('job-offers', require('./HammerApi/vue/job-offers').default);
Vue.component('cheap-fuel', require('./CheapFuel/vue/cheap-fuel').default);

Vue.component('employer-video-ads-list', require('./VideoAds/vue/employer-video-ads-list').default);
Vue.component('video-ad-upload-dialog', require('./VideoAds/vue/dialogs/video-ad-upload-dialog').default);

